module.exports = __webpack_public_path__ + "img/xx.a5d329c8.png";